import { render, staticRenderFns } from "./WriteCustomerList.vue?vue&type=template&id=187e4d4a&scoped=true"
import script from "./WriteCustomerList.vue?vue&type=script&lang=js"
export * from "./WriteCustomerList.vue?vue&type=script&lang=js"
import style0 from "./WriteCustomerList.vue?vue&type=style&index=0&id=187e4d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e4d4a",
  null
  
)

export default component.exports